export default "__VITE_ASSET__BXKRW3Vi__"